import React from 'react';
import classNames from 'classnames';
import { LoadingSpinner } from './LoadingSpinner';
import { indexOf, kebabCase, map } from 'lodash';

const ACCOUNT_PLAYERS_COLUMN_TITLES = [
  'Id', // 0
  'Group', // 1
  'Cohort', // 2
  'Adult', // 3
  'Age Range', // 4
  'Locale', // 5
  'Created At', // 6
  'Last App Touch', // 7
  'Last Activity', // 8
  'Total Plays', // 9
  'Plays during interval', // 10
  'Total Free Plays', // 11
  'Free Plays during interval', // 12
  'Total Photos', // 13
  'Photos during interval', // 14
  'Cards Liked', // 15
  'Cards not Liked', // 16
  'Cards too Hard', // 17
  'Cards too Easy', // 18
  'Cards just Right', // 19
  'Most Recent ASQ', // 20
  'Last message from family', // 21
  'Last Message to family', // 22
]

// const AGES_COLUMN_TITLES = ['Baby 1 (0-4M)', 'Baby 2 (4-8M)',	'Baby 3 (8-12M)', 'Baby 4 (12-18M)', 'Toddler 1 (18-24M)', 'Toddler 2 (24-30M)',	Toddler 3 (30-36M)	Little 3 (3Y)	Little 4 (4Y)	Little 5 (5Y)	Playmakers]

export const accountPlayersColumnsKeys = () => (
  map(ACCOUNT_PLAYERS_COLUMN_TITLES, v => kebabCase(v))
)

export const accountPlayersColumnsOptions = () => (
  map(ACCOUNT_PLAYERS_COLUMN_TITLES, v => { return { value: kebabCase(v), label : v } })
)

export const apColumn = (idx, titles = ACCOUNT_PLAYERS_COLUMN_TITLES) => titles[idx]

export const isColumnOn = (c, options) => indexOf(options, kebabCase(ACCOUNT_PLAYERS_COLUMN_TITLES[c])) !== -1;

export const tableSpinner = () => {
  return (
    <div className='o-rtable__row o-rtable__row--note' key={0}>
      <div className="o-rtable__cell">
        <LoadingSpinner />
      </div>
    </div>
  );
}

export const tableSpinnerDefault = (colSpan) => {
  return (
    <tr key={0} className='cs-bg--light'>
      <td colSpan={colSpan} className='text-center'>
        <LoadingSpinner />
      </td>
    </tr>
  );
}

export const tableNoResults = () => {
  return (
    <div className="o-rtable__row text-center o-rtable__row--note" key={0}>
      <div className="o-rtable__cell u-paddding-top--base u-padding-bottom--base">
         Sorry, no results were found...
      </div>
    </div>
  )
}

export const tableNoResultsDefault = (colSpan) => {
  return (
    <tr key={0} className='cs-bg--light'>
      <td colSpan={colSpan} className={colSpan < 10 ? 'text-center' : 'u-padding-left--base'}>
        Sorry, no results were found...
      </td>
    </tr>
  )
}

export const clsHeaderIcon = (c, meta) => {
  const order = meta.order || 'asc';
  return classNames(
    { 'fa fa-sort o-table-header--icon cs-txt--sp-hr': meta.sort !== c,
      [`fa fa-sort-${order} o-table-header--icon`]: meta.sort === c,
    }
  );
}

export const tableHeaderSort = (key, meta, headers, onSortChange) => {
  return (
    <th data-sort={key} onClick={onSortChange}>
      <span data-sort={key} className='o-table-header--sort'>
        {headers[key]}<i data-sort={key} className={clsHeaderIcon(key, meta)}></i>
      </span>
    </th>
  )
}

export const tableHeaderSortIdx = (idx, meta, headers, onSortChange, titles = ACCOUNT_PLAYERS_COLUMN_TITLES) => {
  const key = headers[idx];
  return (
    <th data-sort={key} onClick={onSortChange}>
      <span data-sort={key} className='o-table-header--sort'>
        {apColumn(idx, titles)}<i data-sort={key} className={clsHeaderIcon(key, meta)}></i>
      </span>
    </th>
  )
}
